'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx2 = require('babel-runtime/helpers/jsx');

var _jsx3 = _interopRequireDefault(_jsx2);

exports.default = Textarea;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

require('./textarea.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * WH Textarea Component.
 * @param {Object} props The new component properties.
 * @returns {React$Element<any>} HTML markup for the component
 */
function Textarea(props) {
    var _props$id = props.id,
        id = _props$id === undefined ? '' : _props$id,
        _props$isDisabled = props.isDisabled,
        isDisabled = _props$isDisabled === undefined ? false : _props$isDisabled,
        onBlur = props.onBlur,
        onChange = props.onChange,
        onFocus = props.onFocus,
        _props$rows = props.rows,
        rows = _props$rows === undefined ? '' : _props$rows,
        _props$name = props.name,
        name = _props$name === undefined ? '' : _props$name,
        _props$className = props.className,
        className = _props$className === undefined ? '' : _props$className;


    return (0, _jsx3.default)('textarea', {
        id: id,
        rows: rows,
        className: className,
        name: name,
        onFocus: onFocus,
        onBlur: onBlur,
        onChange: onChange,
        disabled: isDisabled
    }, void 0, props.children);
}
// css
//# sourceMappingURL=Textarea.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@wh/ui-components/dist/main/components/textarea/Textarea.js
// module id = 617
// module chunks = 0